/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

/**
 * @description 最新版版本号alias
 */
const LATEST_VERSION_KEY = 'latest';
/**
 * @description 预置下载时默认的libraryKey
 */
const PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY = 'BeaconPluginSource';
/**
 * @description 插件本地调试时配置存储key(localStorage)
 */
const PLUGIN_DEBUG_CONFIG_KEY = '__plugin_debug__';

class Log {
    constructor() {
        this.isDebuggerMode = false;
    }
    init(isDebuggerMode) {
        this.isDebuggerMode = isDebuggerMode;
    }
    warn(...args) {
        if (this.isDebuggerMode) {
            console.warn(...args);
        }
    }
}
var Log$1 = new Log();

/**
 * @description 从localStorage里取出debug的插件配置，转换成插件SDK格式的插件配置并缓存
 * @returns 返回生成的插件配置列表
 */
const genDebuggerConfig = () => {
    var _a;
    const plugins = (_a = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem) === null || _a === void 0 ? void 0 : _a.call(localStorage, PLUGIN_DEBUG_CONFIG_KEY);
    if (plugins) {
        try {
            const debugPluginList = JSON.parse(plugins);
            const pluginList = [];
            debugPluginList === null || debugPluginList === void 0 ? void 0 : debugPluginList.forEach((config) => {
                if (config.active) {
                    pluginList.push({
                        code: `${config.key}`,
                        version: config.version,
                        group: config.groupId,
                        icon: config.icon,
                        name: config.name,
                        bizIds: '',
                        purchase: config.purchase,
                        remote: config.remote,
                        type: config.type,
                        debugger: true,
                        versions: [{
                                code: config.key,
                                version: config.version,
                                jsPath: config.resourceUrl,
                                config: JSON.stringify((config === null || config === void 0 ? void 0 : config.versionConfig) || {}),
                            }],
                    });
                }
            });
            return pluginList;
        }
        catch (e) {
            Log$1.warn('加载localStorage中插件配置失败: ', e, plugins);
            return [];
        }
    }
    else {
        return [];
    }
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var eventemitter3 = createCommonjsModule(function (module) {

  var has = Object.prototype.hasOwnProperty,
      prefix = '~';
  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @private
   */

  function Events() {} //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //


  if (Object.create) {
    Events.prototype = Object.create(null); //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //

    if (!new Events().__proto__) prefix = false;
  }
  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @private
   */


  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }
  /**
   * Add a listener for a given event.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} once Specify if the listener is a one-time listener.
   * @returns {EventEmitter}
   * @private
   */


  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') {
      throw new TypeError('The listener must be a function');
    }

    var listener = new EE(fn, context || emitter, once),
        evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  /**
   * Clear event by name.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} evt The Event name.
   * @private
   */


  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
  }
  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @public
   */


  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @public
   */


  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
        events,
        name;
    if (this._eventsCount === 0) return names;

    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };
  /**
   * Return the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Array} The registered listeners.
   * @public
   */


  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event,
        handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [handlers.fn];

    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }

    return ee;
  };
  /**
   * Return the number of listeners listening to a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Number} The number of listeners.
   * @public
   */


  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event,
        listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
  };
  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @public
   */


  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt],
        len = arguments.length,
        args,
        i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;

        case 2:
          return listeners.fn.call(listeners.context, a1), true;

        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;

        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;

        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
          j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;

          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;

          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;

          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;

          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };
  /**
   * Add a listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };
  /**
   * Add a one-time listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };
  /**
   * Remove the listeners of a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {*} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;

    if (!fn) {
      clearEvent(this, evt);
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      } //
      // Reset the array, or remove it completely if we have no more listeners.
      //


      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
    }

    return this;
  };
  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {(String|Symbol)} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @public
   */


  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  }; //
  // Alias methods names because people roll like that.
  //


  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
  // Expose the prefix.
  //

  EventEmitter.prefixed = prefix; //
  // Allow `EventEmitter` to be imported as module namespace.
  //

  EventEmitter.EventEmitter = EventEmitter; //
  // Expose the module.
  //

  {
    module.exports = EventEmitter;
  }
});

/**
 * @description 插件SDK - 【单例】事件中心模块，eventemitter3为基于node eventEmitter的高性能事件中心库，参考：https://github.com/primus/eventemitter3
 */
class EventCenter {
    constructor() {
        // 生成唯一eventEmitter实例
        this.eventEmitter = new eventemitter3();
    }
    /**
     * @description 注册监听事件
     * @param eventName 事件名称
     * @param listener 事件触发执行回调
     * @returns EventCenter
     */
    on(eventName, listener) {
        this.eventEmitter.on(eventName, listener);
        return this;
    }
    /**
     * @description 移除监听事件
     * @param eventName 事件名称
     * @param listener 事件触发执行回调
     * @returns EventCenter
     */
    off(eventName, listener) {
        this.eventEmitter.off(eventName, listener);
        return this;
    }
    /**
     * 触发监听在[eventName]下的所有listeners，按照注册监听的顺序
     * @param eventName 事件名称
     * @param args 搜集触发时参数payload
     * @returns 触发结果
     */
    emit(eventName, ...args) {
        return this.eventEmitter.emit(eventName, ...args);
    }
    /**
     * @description 移除[eventName]下注册的所有监听事件
     * @param eventName 事件名称
     * @returns EventCenter
     */
    removeAllListeners(eventName) {
        this.eventEmitter.removeAllListeners(eventName);
        return this;
    }
    /**
     * @description 移除EventCenter注册的所有事件监听
     * @returns EventCenter
     */
    removeAllEvents() {
        var _a;
        const eventNames = this.eventEmitter.eventNames();
        (_a = eventNames === null || eventNames === void 0 ? void 0 : eventNames.forEach) === null || _a === void 0 ? void 0 : _a.call(eventNames, (eventName) => {
            this.eventEmitter.removeAllListeners(eventName);
        });
        return this;
    }
}
var EventCenter$1 = new EventCenter();

/**
 * @description 插件SDK 事件列表
 */
var PluginSDKEvent;
(function (PluginSDKEvent) {
    // 插件SDK 初始化完成，进入运行状态事件
    PluginSDKEvent["READY"] = "ready";
    // 插件SDK 中插件配置更新完成事件
    PluginSDKEvent["CONFIG_UPDATED"] = "configUpdated";
    // 插件SDK 中插件资源下载完成事件
    PluginSDKEvent["INSTALLED"] = "installed";
    // 插件SDK 销毁前事件
    PluginSDKEvent["BEFORE_DESTROY"] = "beforeDestroy";
    // 插件SDK 完成销毁事件
    PluginSDKEvent["DESTROYED"] = "destroyed";
    // 插件SDK 请求类错误
    PluginSDKEvent["HTTP_ERROR"] = "httpError";
    // 插件SDK 加载到了空的插件资源（包含的情形有：本身就为空或者因异常返回了空的兜底值）
    PluginSDKEvent["EMPTY_PLUGIN_SOURCE"] = "emptyPluginSource";
})(PluginSDKEvent || (PluginSDKEvent = {}));

class PluginCore {
    constructor(params) {
        // 依赖注入
        const { configLoader, sourceInstaller, storage } = params;
        this.configLoader = configLoader;
        this.sourceInstaller = sourceInstaller;
        this.storage = storage;
        // 依赖初始化
        this.initDependencies(params);
        // 插件debug模式初始化
        this.initDebugger();
    }
    /**
     * @description 设置预设插件配置
     * @param pluginConfigList 预设的插件配置列表
     */
    presetPluginConfig(pluginConfigList) {
        this.storage.setPresetConfigList(pluginConfigList);
    }
    /**
     * @description 加载空间下所有插件配置列表
     * @param bizId 空间id
     * @returns PluginConfig[] 插件配置列表
     */
    load(bizId, loader) {
        return __awaiter(this, void 0, void 0, function* () {
            const configList = yield this.configLoader.load(bizId, loader);
            EventCenter$1.emit(PluginSDKEvent.CONFIG_UPDATED, { bizId, configList });
            return configList;
        });
    }
    /**
     * @description 插件资源下载
     * @param pluginCode 插件code
     * @param options 下载配置选项
     * @returns PluginSource 插件资源
     */
    install(pluginCode, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const pluginSource = yield this.sourceInstaller.install(pluginCode, options);
            EventCenter$1.emit(PluginSDKEvent.INSTALLED, { pluginCode, pluginSource });
            return pluginSource;
        });
    }
    /**
     * @description 导入插件资源
     * @param pluginCode 插件code
     * @param options 下载配置选项
     * @returns PluginSource 插件资源
     */
    import(pluginCode, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const pluginSource = yield this.install(pluginCode, options);
            const pluginConfig = yield this.configLoader.loadByPluginCode(pluginCode);
            const pluginSourceWithConfig = Object.assign(Object.assign({}, pluginConfig), { pluginSource });
            if (!pluginSource) {
                const emptyPluginSourceEventPayload = {
                    pluginConfig: pluginSourceWithConfig,
                    pluginCode,
                    options,
                };
                EventCenter$1.emit(PluginSDKEvent.EMPTY_PLUGIN_SOURCE, emptyPluginSourceEventPayload);
            }
            if (pluginConfig && (options === null || options === void 0 ? void 0 : options.withConfig)) {
                return pluginSourceWithConfig;
            }
            return pluginSource !== null && pluginSource !== void 0 ? pluginSource : null;
        });
    }
    /**
     * @description 导出存储模块
     */
    getStorage() {
        return this.storage;
    }
    /**
     * @description 对注入的依赖进行初始化
     * @param params 初始化参数
     */
    initDependencies(params) {
        // 初始化loader
        const loaderInitParams = {
            host: params.host,
            storage: params.storage,
        };
        this.configLoader.init(loaderInitParams);
        // 初始化installer
        const installerInitParams = {
            configLoader: params.configLoader,
            storage: params.storage,
        };
        this.sourceInstaller.init(installerInitParams);
    }
    /**
     * @description 加载调试插件
     */
    initDebugger() {
        this.storage.setDebuggerConfigList(genDebuggerConfig());
    }
}

/**
 * @description 深拷贝函数
 */
const deepClone = (obj, hash = new WeakMap()) => {
    var _a;
    if (hash.has(obj)) {
        return obj;
    }
    let result = {};
    const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error];
    if (reference.includes(obj === null || obj === void 0 ? void 0 : obj.constructor)) {
        result = new obj.constructor(obj);
    }
    else if (Array.isArray(obj)) {
        result = [];
        obj.forEach((e, i) => {
            result[i] = deepClone(e);
        });
    }
    else if (typeof obj === 'object' && obj !== null) {
        result = {};
        (_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.forEach((key) => {
            if (Object.hasOwnProperty.call(obj, key)) {
                result[key] = deepClone(obj[key]);
            }
        });
        hash.set(obj, result);
    }
    else {
        result = obj;
    }
    return result;
};
/**
 * @description 检查插件配置是否合法
 */
const checkPluginConfig = (pluginConfig) => {
    const { code, group, version, versions } = pluginConfig !== null && pluginConfig !== void 0 ? pluginConfig : [];
    if (code && group && version && versions)
        return true;
    return false;
};
/**
 * @description 获取uuid
 * @returns {string}
 */
const getUUID = () => 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
});

const exceptionResponse = {
    code: -1,
    message: '',
    data: null,
    result: null,
};
class HTTPRequest {
    constructor() {
        this.host = '';
    }
    init(host) {
        this.host = host;
    }
    get(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({
                url,
                method: 'GET',
            });
        });
    }
    request(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const fetchOptions = {
                method: options.method,
                mode: 'cors',
                credentials: 'include',
                headers: {
                    accept: 'application/json, text/plain, */*',
                    'content-type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: options.body ? JSON.stringify(options.body) : null,
            };
            try {
                const response = yield fetch(this.buildURL(options.url), fetchOptions);
                if (response.ok) {
                    return response.json();
                }
                throw response;
            }
            catch (e) {
                const errorConfig = { url: options.url, options, error: e };
                Log$1.warn('插件SDK发起请求异常:', fetchOptions, errorConfig);
                EventCenter$1.emit(PluginSDKEvent.HTTP_ERROR, errorConfig);
                return exceptionResponse;
            }
        });
    }
    buildURL(url) {
        const logTraceId = getUUID();
        let requestUrl = `${this.host}${url}`;
        if ((requestUrl === null || requestUrl === void 0 ? void 0 : requestUrl.indexOf('?')) !== -1) {
            requestUrl += `&log_trace_id=${logTraceId}`;
        }
        else {
            requestUrl += `?log_trace_id=${logTraceId}`;
        }
        return requestUrl;
    }
}
var http = new HTTPRequest();

class PluginConfigLoader {
    constructor() {
        this.loadPromiseBizIdMap = new Map();
        this.loadPromiseCodeMap = new Map();
    }
    /**
     * 进行loader初始化操作
     * @param params loader初始化参数
     */
    init(params) {
        // 初始化http服务
        http.init(params.host);
        // 插件存储服务依赖注入
        this.storage = params.storage;
    }
    /**
     * 获取空间下所有插件的配置列表
     * @param bizId 空间id
     * @param loader 配置参数
     * @returns 空间下所有的插件配置列表
     */
    load(bizId, loader = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // 获取预设的插件配置
            const presetPluginConfigList = yield this.storage.getPresetPluginConfigList(bizId);
            // 获取远端插件配置
            const remotePluginConfigList = (_a = yield this.loadAll(bizId, loader)) !== null && _a !== void 0 ? _a : [];
            // 获取本地调试插件配置
            const debuggerPluginConfigList = yield this.storage.getDebuggerPluginConfigList();
            // 合并后筛选相应插件配置返回
            return this.filter(
            // 合并preset和远端插件配置
            this.mergeRemotePluginConfig(presetPluginConfigList, remotePluginConfigList, debuggerPluginConfigList), loader);
        });
    }
    /**
     * 返回指定插件配置
     * @param pluginCode 插件code
     * @returns 对应插件配置
     */
    loadByPluginCode(pluginCode, loader = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(loader === null || loader === void 0 ? void 0 : loader.refresh)) {
                // 1.如果有对应的调试插件配置，优先返回
                const debuggerPluginConfig = yield this.storage.getDebuggerPluginConfig(pluginCode);
                if (debuggerPluginConfig) {
                    return debuggerPluginConfig;
                }
                // 2.如果有预设的插件配置，返回
                const presetPluginConfig = yield this.storage.getPresetPluginConfig(pluginCode);
                if (presetPluginConfig) {
                    // 不合并远端配置
                    if (!loader.syncRemoteConfig) {
                        return presetPluginConfig;
                    }
                    // 合并远端配置
                    const pluginConfig = yield this.loadPlugin(pluginCode, loader);
                    if (pluginConfig) {
                        return Object.assign(Object.assign({}, pluginConfig), presetPluginConfig);
                    }
                    return presetPluginConfig;
                }
            }
            return this.loadPlugin(pluginCode, loader);
        });
    }
    /**
     * @description 初始化，添加预设的插件配置
     */
    mergeRemotePluginConfig(presetList = [], remoteList = [], debuggerList = []) {
        const result = deepClone(presetList);
        // 合并远端与预设配置
        remoteList.forEach((config) => {
            const index = presetList.findIndex(cfg => cfg.code === config.code);
            if (index > -1) {
                result.splice(index, 1, Object.assign(Object.assign({}, config), presetList[index]));
            }
            else {
                result.push(config);
            }
        });
        // 合并debugger配置与最终配置
        debuggerList.forEach((config) => {
            const index = result.findIndex(cfg => cfg.code === config.code);
            if (index > -1) {
                result.splice(index, 1, config);
            }
            else {
                result.push(config);
            }
        });
        return result;
    }
    /**
     * @description 初始化，添加预设的插件配置
     */
    filter(configList = [], loader) {
        return __awaiter(this, void 0, void 0, function* () {
            let list = yield this.replaceDebuggerPluginConfig(deepClone(configList));
            if (list.length && (loader === null || loader === void 0 ? void 0 : loader.group)) {
                list = list.filter(config => config.group === loader.group);
            }
            return list;
        });
    }
    /**
     * @description 根据code替换debugger插件的配置
     */
    replaceDebuggerPluginConfig(configList = []) {
        return __awaiter(this, void 0, void 0, function* () {
            // 获取debugger的插件配置
            const debuggerPluginConfigList = yield this.storage.getDebuggerPluginConfigList();
            debuggerPluginConfigList.forEach((config, index) => {
                const idx = configList === null || configList === void 0 ? void 0 : configList.findIndex(cfg => cfg.code === config.code);
                if (idx > -1) {
                    configList === null || configList === void 0 ? void 0 : configList.splice(idx, 1, debuggerPluginConfigList[index]);
                }
                else {
                    configList.push(debuggerPluginConfigList[index]);
                }
            });
            return configList;
        });
    }
}

/**
 * @description 返回空间下所有插件的配置
 */
const loadAllPluginConfig = (bizId, corpId = '') => __awaiter(void 0, void 0, void 0, function* () { return http.get(`/api/suiteserver/plugin/list?bizId=${bizId}&corp=${corpId}`); });
/**
 * @description 返回指定插件code的插件配置
 */
const loadPluginConfig = (pluginCode) => __awaiter(void 0, void 0, void 0, function* () { return http.get(`/api/suiteserver/plugin/detail?code=${pluginCode}`); });

class PluginConfigDefaultLoader extends PluginConfigLoader {
    loadAll(bizId, loader) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const loadPromiseMapKey = `${bizId}$$${(_a = loader.corpId) !== null && _a !== void 0 ? _a : ''}`;
            // 查询有没有存在的promise，避免二次请求
            let loadPluginConfigPromise = this.loadPromiseBizIdMap.get(loadPromiseMapKey);
            // 没有promise或者强刷时，刷新promise
            if (!loadPluginConfigPromise || (loader === null || loader === void 0 ? void 0 : loader.refresh)) {
                loadPluginConfigPromise = loadAllPluginConfig(bizId, loader.corpId);
                this.loadPromiseBizIdMap.set(loadPromiseMapKey, loadPluginConfigPromise);
            }
            try {
                const result = yield loadPluginConfigPromise;
                if ((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.length) {
                    const pluginConfigList = (_c = result.data) === null || _c === void 0 ? void 0 : _c.map(config => Object.assign(config, {
                        remote: true,
                    }));
                    this.storage.setConfigList(pluginConfigList);
                    return pluginConfigList;
                }
                return [];
            }
            catch (e) {
                Log$1.warn(`加载空间[${bizId}]插件配置列表失败: `, e);
                return [];
            }
        });
    }
    ;
    loadPlugin(pluginCode, loader) {
        return __awaiter(this, void 0, void 0, function* () {
            // 查询有没有缓存过插件配置，有则直接返回
            const cachePluginConfig = yield this.storage.getConfig(pluginCode);
            if (cachePluginConfig && !(loader === null || loader === void 0 ? void 0 : loader.refresh)) {
                return cachePluginConfig;
            }
            // 查询有没有存在的promise，避免二次请求
            let loadPromise = this.loadPromiseCodeMap.get(pluginCode);
            // 没有promise且没有缓存过插件配置或者强刷时，刷新promise
            if (!loadPromise || (loader === null || loader === void 0 ? void 0 : loader.refresh)) {
                loadPromise = loadPluginConfig(pluginCode);
                this.loadPromiseCodeMap.set(pluginCode, loadPromise);
            }
            try {
                const result = yield loadPromise;
                if (checkPluginConfig(result === null || result === void 0 ? void 0 : result.data)) {
                    const pluginConfig = Object.assign(result.data, {
                        remote: true,
                    });
                    this.storage.setConfig(pluginConfig);
                    return pluginConfig;
                }
                Log$1.warn(`插件[${pluginCode}]配置不合法: `, result.data);
                return null;
            }
            catch (e) {
                Log$1.warn(`加载插件[${pluginCode}]配置失败: `, e);
                return null;
            }
        });
    }
}
var PluginConfigDefaultLoader$1 = new PluginConfigDefaultLoader();

class PluginInstaller {
    constructor() {
        this.installPromiseMap = new Map();
    }
    init(params) {
        // 注入插件配置加载模块依赖
        this.configLoader = params.configLoader;
        // 注入插件存储模块依赖
        this.storage = params.storage;
    }
    install(pluginCode, config) {
        return __awaiter(this, void 0, void 0, function* () {
            // 查询插件配置
            const pluginConfig = yield this.configLoader.loadByPluginCode(pluginCode, {
                refresh: config === null || config === void 0 ? void 0 : config.refresh,
                syncRemoteConfig: config === null || config === void 0 ? void 0 : config.syncRemoteConfig,
            });
            if (!pluginConfig) {
                // 没有找到对应插件资源
                Log$1.warn(`没有找到插件[${pluginCode}]的配置, 无法下载资源`);
                return null;
            }
            // 插件配置已经带了插件资源，故直接返回
            if (pluginConfig.pluginSource) {
                Log$1.warn(`插件[${pluginCode}]已经预设插件资源，直接返回`);
                return pluginConfig.pluginSource;
            }
            // 否则执行下载资源
            return this.installPlugin(pluginConfig, config);
        });
    }
    /**
     * @description 构造插件存储唯一key，用于前端存储
     */
    getStorageKey(pluginConfig, options) {
        var _a, _b;
        const targetVersion = (_b = (_a = options === null || options === void 0 ? void 0 : options.version) !== null && _a !== void 0 ? _a : pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.version) !== null && _b !== void 0 ? _b : LATEST_VERSION_KEY;
        return `${pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.code}$$${targetVersion}`;
    }
    /**
     * @description 获取插件资源路径url
     */
    getLibraryURL(pluginConfig, options) {
        var _a, _b, _c, _d;
        const targetVersion = (_b = (_a = options === null || options === void 0 ? void 0 : options.version) !== null && _a !== void 0 ? _a : pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.version) !== null && _b !== void 0 ? _b : LATEST_VERSION_KEY;
        const versionInfo = (_c = pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.versions) === null || _c === void 0 ? void 0 : _c.find((item) => item.version === targetVersion);
        return (_d = versionInfo === null || versionInfo === void 0 ? void 0 : versionInfo.jsPath) !== null && _d !== void 0 ? _d : '';
    }
    /**
     * @description 从缓存获取插件资源逻辑
     */
    getSourceFromStorage(pluginStorageKey, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // 设置了强刷，不返回缓存
            if (options === null || options === void 0 ? void 0 : options.refresh) {
                return null;
            }
            // 下载过该插件，返回缓存的资源
            const pluginSource = (_a = yield this.storage.getSource(pluginStorageKey)) !== null && _a !== void 0 ? _a : null;
            return this.handlePluginSource(pluginSource);
        });
    }
    /**
     * @description 新下载插件资源核心逻辑
     */
    installPlugin(pluginConfig, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const pluginCode = pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.code;
            const libraryURL = this.getLibraryURL(pluginConfig);
            const pluginStorageKey = this.getStorageKey(pluginConfig, config);
            if (!pluginCode || !libraryURL) {
                Log$1.warn(`插件[${pluginCode}]配置不完整，下载异常: `, pluginConfig);
                return null;
            }
            // 先查缓存看有没有下载完成的资源，有则直接返回
            const pluginSource = yield this.getSourceFromStorage(pluginStorageKey, config);
            if (pluginSource && !(config === null || config === void 0 ? void 0 : config.refresh)) {
                return pluginSource;
            }
            // 查看有没有下载中的promise，有则直接返回
            let installPromise = this.installPromiseMap.get(pluginStorageKey);
            if (installPromise && !(config === null || config === void 0 ? void 0 : config.refresh)) {
                return installPromise;
            }
            // 无下载中也无下载完成的资源，构建好下载promise并缓存和返回
            installPromise = this.installPluginSource(pluginStorageKey, libraryURL, pluginCode, config);
            this.installPromiseMap.set(pluginStorageKey, installPromise);
            return installPromise;
        });
    }
}

class PluginDefaultInstaller extends PluginInstaller {
    installPluginSource(pluginStorageKey, url, pluginCode, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                var _a, _b;
                const script = document.createElement('script');
                script.id = `${PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY}_${pluginStorageKey}`;
                script.async = true;
                script.src = url;
                script.onload = () => {
                    Log$1.warn(`插件[${pluginStorageKey}]下载完成：`, window[PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY], window[pluginCode]);
                    let pluginSource = null;
                    if (config === null || config === void 0 ? void 0 : config.libraryKey) {
                        pluginSource = deepClone(window[config === null || config === void 0 ? void 0 : config.libraryKey]);
                    }
                    else {
                        pluginSource = deepClone(window[pluginCode] || window[PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY]);
                    }
                    this.storage.setSource(pluginStorageKey, pluginSource);
                    resolve(pluginSource);
                    // 移除window上挂载的属性
                    setTimeout(() => {
                        (config === null || config === void 0 ? void 0 : config.libraryKey) && window[config === null || config === void 0 ? void 0 : config.libraryKey] && delete window[config === null || config === void 0 ? void 0 : config.libraryKey];
                        window[pluginCode] && delete window[pluginCode];
                        window[PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY] && delete window[PLUGIN_INSTALL_DEFAULT_LIBRARY_KEY];
                    }, 1000);
                };
                script.onerror = (error) => {
                    const errConfig = { url, pluginCode, error };
                    Log$1.warn(`插件[${pluginStorageKey}]下载异常：`, errConfig);
                    EventCenter$1.emit(PluginSDKEvent.HTTP_ERROR, errConfig);
                    resolve(null);
                };
                (_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.append) === null || _b === void 0 ? void 0 : _b.call(_a, script);
            });
        });
    }
    ;
    handlePluginSource(pluginSource) {
        // 下载过该插件，返回缓存的资源
        return pluginSource;
    }
}
var PluginDefaultInstaller$1 = new PluginDefaultInstaller();

class PluginStorage {
}

class PluginMemoryStorage extends PluginStorage {
    constructor() {
        super();
        this.pluginConfigMap = new Map();
        this.presetPluginConfigMap = new Map();
        this.debuggerPluginConfigMap = new Map();
        this.pluginSourceMap = new Map();
    }
    setConfig(pluginConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            if (pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.code) {
                this.pluginConfigMap.set(pluginConfig.code, pluginConfig);
            }
            else {
                Log$1.warn('插件配置缺失code字段，缓存失败: ', pluginConfig);
            }
        });
    }
    setConfigList(pluginConfigList = []) {
        return __awaiter(this, void 0, void 0, function* () {
            pluginConfigList.forEach((config) => {
                if (config === null || config === void 0 ? void 0 : config.code) {
                    this.pluginConfigMap.set(config.code, config);
                }
                else {
                    Log$1.warn('插件配置缺失code字段，缓存失败: ', config);
                }
            });
        });
    }
    setPresetConfigList(pluginConfigList = []) {
        return __awaiter(this, void 0, void 0, function* () {
            pluginConfigList.forEach((config) => {
                if (config === null || config === void 0 ? void 0 : config.code) {
                    this.presetPluginConfigMap.set(config.code, config);
                }
                else {
                    Log$1.warn('预设插件配置缺失code字段，缓存失败: ', config);
                }
            });
        });
    }
    setDebuggerConfigList(pluginConfigList = []) {
        return __awaiter(this, void 0, void 0, function* () {
            pluginConfigList.forEach((config) => {
                if (config === null || config === void 0 ? void 0 : config.code) {
                    this.debuggerPluginConfigMap.set(config.code, config);
                }
                else {
                    Log$1.warn('debugger插件配置缺失code字段，缓存失败: ', config);
                }
            });
        });
    }
    getConfig(pluginCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve((_a = this.pluginConfigMap.get(pluginCode)) !== null && _a !== void 0 ? _a : null);
        });
    }
    getConfigByBizId(bizId) {
        var _a;
        const pluginConfigList = [];
        (_a = this.pluginConfigMap) === null || _a === void 0 ? void 0 : _a.forEach((config) => {
            var _a;
            if (bizId && ((_a = config === null || config === void 0 ? void 0 : config.bizIds) === null || _a === void 0 ? void 0 : _a.includes(bizId))) {
                pluginConfigList.push(deepClone(config));
            }
        });
        return Promise.resolve(pluginConfigList);
    }
    getPresetPluginConfig(pluginCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve((_a = this.presetPluginConfigMap.get(pluginCode)) !== null && _a !== void 0 ? _a : null);
        });
    }
    getPresetPluginConfigList(bizId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const pluginConfigList = [];
            (_a = this.presetPluginConfigMap) === null || _a === void 0 ? void 0 : _a.forEach((config) => {
                var _a;
                const seedConfig = deepClone(config);
                if (!(config === null || config === void 0 ? void 0 : config.bizIds)) {
                    pluginConfigList.push(seedConfig);
                }
                if (bizId && ((_a = config === null || config === void 0 ? void 0 : config.bizIds) === null || _a === void 0 ? void 0 : _a.includes(bizId))) {
                    pluginConfigList.push(seedConfig);
                }
            });
            return Promise.resolve(pluginConfigList);
        });
    }
    getDebuggerPluginConfigList() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const pluginConfigList = [];
            (_a = this.debuggerPluginConfigMap) === null || _a === void 0 ? void 0 : _a.forEach((config) => {
                pluginConfigList.push(deepClone(config));
            });
            return Promise.resolve(pluginConfigList);
        });
    }
    getDebuggerPluginConfig(pluginCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve((_a = this.debuggerPluginConfigMap.get(pluginCode)) !== null && _a !== void 0 ? _a : null);
        });
    }
    setSource(pluginStorageKey, pluginSource) {
        return __awaiter(this, void 0, void 0, function* () {
            this.pluginSourceMap.set(pluginStorageKey, pluginSource);
        });
    }
    ;
    getSource(pluginStorageKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.pluginSourceMap.get(pluginStorageKey);
        });
    }
    ;
    deleteSource(pluginStorageKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.pluginSourceMap.delete(pluginStorageKey);
        });
    }
    ;
}
var PluginMemoryStorage$1 = new PluginMemoryStorage();

const getVersionConfig = function (pluginConfig, version) {
    var _a;
    const versions = (_a = pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.versions) !== null && _a !== void 0 ? _a : [];
    const versionConfig = versions.find(v => v.version === version);
    if (!versionConfig)
        return Object.assign({}, pluginConfig);
    return Object.assign({}, pluginConfig, {
        versionConfig: versionConfig === null || versionConfig === void 0 ? void 0 : versionConfig.config,
        versionJSPath: versionConfig === null || versionConfig === void 0 ? void 0 : versionConfig.jsPath,
    });
};
const pluginSDKUtils = {
    getVersionConfig,
};

class PluginCoreEntry {
    /**
     * @description PluginCoreEntry类不需要实例化
     */
    constructor() { }
    /**
     * @description 初始化插件SDK
     * @param config PluginCoreEntryConstructorParams 插件SDK初始化入参
     */
    static init(config) {
        var _a, _b, _c, _d, _e;
        if (!PluginCoreEntry.pluginCoreInstance) {
            this.debuggerMode = (_a = config === null || config === void 0 ? void 0 : config.debug) !== null && _a !== void 0 ? _a : false;
            Log$1.init(this.debuggerMode);
            const pluginCoreParams = {
                host: (_b = config === null || config === void 0 ? void 0 : config.host) !== null && _b !== void 0 ? _b : '',
                configLoader: (_c = config === null || config === void 0 ? void 0 : config.configLoader) !== null && _c !== void 0 ? _c : PluginConfigDefaultLoader$1,
                sourceInstaller: (_d = config === null || config === void 0 ? void 0 : config.sourceInstaller) !== null && _d !== void 0 ? _d : PluginDefaultInstaller$1,
                storage: (_e = config === null || config === void 0 ? void 0 : config.storage) !== null && _e !== void 0 ? _e : PluginMemoryStorage$1,
            };
            PluginCoreEntry.pluginCoreInstance = new PluginCore(pluginCoreParams);
            EventCenter$1.emit(PluginSDKEvent.READY);
        }
    }
    /**
     * @description 在某空间下预设插件配置
     * @param bizId 空间id
     * @param pluginConfigList 预设的插件配置列表
     */
    static presetPluginConfig(pluginConfigList) {
        if (this.checkRequirement({ pluginConfigList })) {
            PluginCoreEntry.pluginCoreInstance.presetPluginConfig(pluginConfigList);
        }
    }
    /**
     * @description 加载插件配置列表
     * @param bizId 空间id
     * @returns Promise<PluginConfig[]> 插件配置列表
     */
    static load(bizId, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            let configList = null;
            if (this.checkRequirement()) {
                configList = yield PluginCoreEntry.pluginCoreInstance.load(bizId, options);
            }
            return configList;
        });
    }
    /**
     * @description 下载指定插件资源
     * @param pluginCode 插件code
     * @param options 下载选项
     * @returns Promise<PluginSource> 插件资源
     */
    static install(pluginCode, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let pluginSource = null;
            if (this.checkRequirement({ pluginCode })) {
                pluginSource = yield PluginCoreEntry.pluginCoreInstance.install(pluginCode, options);
            }
            return pluginSource;
        });
    }
    /**
     * @description 导入指定插件资源使用
     * @param pluginCode 插件code
     * @param options 导入选项
     * @returns PluginSource 插件资源
     */
    static import(pluginCode, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let pluginSourceObject = null;
            if (this.checkRequirement({ pluginCode })) {
                pluginSourceObject = yield PluginCoreEntry.pluginCoreInstance.import(pluginCode, options);
            }
            return pluginSourceObject;
        });
    }
    /**
     * @description 注册监听事件
     * @param eventName 事件名称
     * @param listener 事件触发执行回调
     */
    static on(eventName, listener) {
        EventCenter$1.on(eventName, listener);
    }
    /**
     * @description 移除监听事件
     * @param eventName 事件名称
     * @param listener 事件触发执行回调
     */
    static off(eventName, listener) {
        if (this.checkRequirement({ eventName, listener })) {
            EventCenter$1.off(eventName, listener);
        }
    }
    /**
     * @description 销毁插件SDK
     * @returns EventCenter
     */
    static destroy() {
        EventCenter$1.emit(PluginSDKEvent.BEFORE_DESTROY, PluginCoreEntry);
        EventCenter$1.removeAllEvents();
        EventCenter$1.emit(PluginSDKEvent.DESTROYED, PluginCoreEntry);
    }
    /**
     * @description 获取调试模块
     * @returns PluginStorage
     */
    static debugger() {
        if (this.debuggerMode) {
            return PluginCoreEntry.pluginCoreInstance.getStorage();
        }
    }
    /**
     * @description 接口调用前置条件检查
     * @param params 需要检查的参数列表
     * @returns boolean 检查结果
     */
    static checkRequirement(params = {}) {
        var _a;
        if (!PluginCoreEntry.pluginCoreInstance) {
            Log$1.warn('插件SDK暂未初始化，调用BeaconPlugin.init()进行初始化');
            return false;
        }
        let result = true;
        (_a = Object.keys(params)) === null || _a === void 0 ? void 0 : _a.forEach((key) => {
            if (params[key] === undefined) {
                Log$1.warn(`传参错误，参数[${key}]必填`);
                result = false;
            }
        });
        return result;
    }
}
/**
 * @description SDK工具集模块
 * @returns PluginSDKUtil
 */
PluginCoreEntry.utils = pluginSDKUtils;

export { PluginCoreEntry as default };
